import { Promise } from 'q'

/**
 *改变文本的样式
 */
function changeStyle(type, elements, col, index) {
  if (col[index].type === type) {
    let prop = col[index].prop
    if (col[index].color) {
      var color = col[index].color
    }
    if (col[index].fontWeight) {
      var fontWeight = col[index].fontWeight
    }

    for (var j = 0; j < elements.length; j++) {
      if (elements[j].htmlFor.trim() === col[index].prop) {
        elements[j].nextSibling.getElementsByTagName(type)[0].style.color = color
        if (fontWeight) {
          elements[j].nextSibling.getElementsByTagName(type)[0].style.fontWeight = 'bold'
        }
      }
    }
  }
}

/**
 * 展示和预览分割线前面标签的移除
 */
function changeDividerAll(allElements, col, index) {
  for (var j = 0; j < allElements.length; j++) {
    /* if(allElements[j].htmlFor !== col[index].prop || allElements[j].nextSibling.getElementsByClassName('el-divider__text').length === 0){
            allElements[j].style.display = ''
            allElements[j].nextSibling.style.marginLeft = '100px'
        }*/

    if (allElements[j].htmlFor === col[index].prop && allElements[j].nextSibling.getElementsByClassName('el-divider__text').length > 0) {
      allElements[j].style.display = 'none'
      allElements[j].nextSibling.style.marginLeft = '0px'
      // console.log('el-divider--horizontal')
      // console.log(allElements[j].nextSibling.getElementsByClassName('el-divider--horizontal'))
    }
  }
}

function changeDivider(elements, col, index) {
  setTimeout(() => {
    changeDividerAll(elements, col, index)
  })
}

function changeDynamic(elements, col, index) {
  for (let j = 0; j < elements.length; j++) {
    if (elements[j].htmlFor === col[index].prop && elements[j].nextSibling.getElementsByClassName('avue-crud').length > 0) {
      if (col[index].disabled) { // 子表单不可用时设置增添按钮不可点击
        var curd = elements[j].nextSibling.getElementsByClassName('avue-crud')
        setTimeout(() => {
          console.log(curd)
          let crudBtn = curd[0].getElementsByTagName('thead')
          let pBtn = crudBtn[1].getElementsByTagName('button')
          pBtn[0].disabled = true
        })
      }
    }
  }
}

/**
 * 动态表单配置中一些属性的改变渲染到表单中
 * @param ele
 * @param widgetForm
 */
export function changeConfigToForm(ele, widgetForm) {
  let elements = []
  for (let i = 0; i < ele.length; i++) {
    if (ele[i].htmlFor) {
      elements.push(ele[i])
    }
  }
  let col = widgetForm.column

  for (let i = 0; i < col.length; i++) {
    if (col[i].type === 'input') {
      changeStyle('input', elements, col, i)
    } else if (col[i].type === 'textarea') {
      changeStyle('textarea', elements, col, i)
    } else if (col[i].type === 'divider') {
      changeDivider(elements, col, i)
    } /* else if (col[i].type === 'dynamic') {
            changeDynamic(elements, col, i)
        }*/
    for (let j = 0; j < elements.length; j++) {
      if (elements[j].nextSibling.getElementsByClassName('el-divider__text').length === 0) {
        elements[j].style.display = ''
        elements[j].nextSibling.style.marginLeft = '100px'
      }
    }
  }
}

/**
 * js的引入
 * @param modelJson
 */
export function loadJs(modelJson) {
  if (modelJson.jsPath && modelJson.jsPath.endsWith('.js')) { // 引入js
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = modelJson.jsPath
    script.id = modelJson.formId
    document.body.appendChild(script)
  }
}

/**
 * onclick点击事件的执行
 * @param mode
 * @param conf
 * @param modeProp
 */
export function openMode(mode, conf, modeProp) {
  console.log('hello i mode a data')
  let idx1 = mode.indexOf('(')
  let idx2 = mode.indexOf(')')
  let modeSubStr = mode.substring(idx1 + 1, idx2)
  let modeSubStrSplits = modeSubStr.split(',')
  conf.mainTable.buttonSetting.modeConf.title = modeSubStrSplits[0].trim().replace(/\'/g, '')
  conf.mainTable.buttonSetting.modeConf.doubleClick = JSON.parse(modeSubStrSplits[1].trim())
  conf.mainTable.buttonSetting.modeConf.toLabel = modeSubStrSplits[2].trim().replace(/\'/g, '')
  conf.mainTable.buttonSetting.modeConf.urlStr = modeSubStrSplits[3].trim().replace(/\'/g, '')
  conf.mainTable.buttonSetting.modeConf.modeProp = modeProp
  conf.mainTable.buttonSetting.visible = true
}

/**
 * 根据流程中字段的属性控制表单字段的属性，主要是流程中可读可写属性对应到表单中
 * @param formModelJson
 * @param taskFormJson
 */
export function changeFormModelUsingTaskForm(formModelJson, taskFormJson) { // 对从后端返回的表单模型数据做改变
  console.log(formModelJson)
  for (let i = 0; i < formModelJson.column.length; i++) {
    let j
    if (formModelJson.column[i].display === false) continue
    for (j = 0; j < taskFormJson.length; j++) {
      if (formModelJson.column[i].prop === taskFormJson[j].id) {
        if (taskFormJson[j].required) {
          formModelJson.column[i].required = true
        }
        if (taskFormJson[j].readable && !taskFormJson[j].writable) {
          formModelJson.column[i].disabled = true
          // 下面一行 ZHJI 2020/02/11 新增，溢出关于只读元素的必填校验
          formModelJson.column[i].required = false
          formModelJson.column[i].rules = []
        }
        break
      }
    }
    if (formModelJson.column[i].type === 'dynamic' && formModelJson.column[i].disabled === true) {
      formModelJson.column[i].children.addBtn = false
      formModelJson.column[i].children.delBtn = false
    }
    if (taskFormJson.length > 0) {
      if (j === taskFormJson.length) {
        formModelJson.column[i].display = false
      }
    }
  }
}

/**
 * //根据表单配置，加载属性
 * @param modelJson
 * @param conf
 */
export function modifyFormModelData(modelJson, conf) {
  for (let i = 0; i < modelJson.column.length; i++) { // 解析文本框中的onclick函数
    if (modelJson.column[i].mode && modelJson.column[i].mode.length > 0) {
      modelJson.column[i].click = function open() {
        openMode(modelJson.column[i].mode, conf, modelJson.column[i].prop)
      }
    }
    // if (modelJson.column[i].type === 'hyperLink') {
    //   modelJson.column[i].title = modelJson.column[i].label
    //   modelJson.column[i].label = ''
    // }
    if (modelJson.column[i].type === 'dynamic') { // 根据配置设置子表单中元素的显隐
      let child = modelJson.column[i].children.column
      for (let j = 0; j < child.length; j++) {
        if (!child[j].hasOwnProperty('hide') && child[j].display === false) {
          modelJson.column[i].children.column[j].hide = true
        }
      }
    }
  }
}

/**
 * //点击上传组件下的文件列表中的某个文件时下载文件行为
 * @param refs
 * @param downloadFile
 * @param modelData
 * @param message
 */
export function donwloadFileOnClick(refs, downloadFile, modelData, message) {
  let childrenList = refs.$children[0].$children[0].$children[0].$children[0].$children
  console.log('childrelist')
  console.log(childrenList)
  console.log(refs)
  for (let i = 0; i < childrenList.length; i++) {
    if (!childrenList[i].$children[0] || !childrenList[i].$children[0].$children[1] || childrenList[i].$children[0].$children[1].$children[0].$children[0] === undefined) {
      continue
    }
    console.log(childrenList[i].$children[0].$children[1].$children[0].$children[0].type)
    if (childrenList[i].$children[0].$children[1].$children[0].$children[0].type === 'upload') {
      let uploadProp = childrenList[i].$children[0].$children[1].$children[0].$children[0].prop
      if (childrenList[i].$children[0].$children[1].$children[0].$children[0].disabled === true) {
        childrenList[i].$children[0].$children[1].$children[0].$children[0].readonly = true
        console.log('hello upload')
        console.log(childrenList[i].$children[0].$children[1].$children[0].$children[0])
        console.log(childrenList[i].$children[0].$children[1].$children[0].$children[0].$el)
        console.log(childrenList[i].$children[0].$children[1].$children[0].$children[0].$el.getElementsByClassName('el-upload'))
        if (childrenList[i].$children[0].$children[1].$children[0].$children[0].$el.getElementsByTagName('li').length === 0) {
          childrenList[i].$children[0].$children[1].$children[0].$children[0].$el.getElementsByTagName('ul')[0].innerHTML = '暂无附件'
        }
        console.log(childrenList[i].$children[0].$children[1].$children[0].$children[0].$el.getElementsByTagName('li'))
        childrenList[i].$children[0].$children[1].$children[0].$children[0].$el.getElementsByClassName('el-upload')[0].style.display = 'none'
        childrenList[i].$children[0].$children[1].$children[0].$children[0].disabled = false
      }
      console.log(modelData[uploadProp])
      if (modelData[uploadProp] && modelData[uploadProp].length > 0) {
        childrenList[i].$children[0].$children[1].$children[0].$children[0].handlePreview = (file) => {
          if (modelData[uploadProp] && modelData[uploadProp].length > 0) {
            for (let j = 0; j < modelData[uploadProp].length; j++) {
              if (modelData[uploadProp][j].label === file.name) {
                console.log(modelData[uploadProp][j].label)
                downloadFile.get('/common/document/download?fileUniqueCode=' + modelData[uploadProp][j].code, { params: {
                  doDownload: false,
                  fileName: '111.png'
                }}).then(res => {
                  if (res.code === 200) {
                    modelData[uploadProp][j].value = res.data.url
                    let dom = document.createElement('a')// 设置一个隐藏的a标签，href为输出流，设置download
                    dom.style.display = 'none'
                    dom.href = res.data.url
                    dom.setAttribute('download', file.name)// 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
                    document.body.appendChild(dom)
                    dom.click()
                  }
                }).catch(err => {
                  if (err.msg) { message.error(err.msg) } else { message.error(err.message) }
                })
              }
            }
          }
        }
      }
    }
  }
}

/**
 * 下一环节审核人弹框中确认按钮点击事件
 * @param modeData
 * @param formModel
 * @param formInstance
 * @param mainTable
 * @param modeProp
 */
export function setMode(modeData, formModel, formInstance, mainTable, modeProp) { // 会签环节的下一步审核人
  console.log(modeData)
  console.log(mainTable)
  if (modeData instanceof Array) {
    console.log('array')
    let idStr = []
    let nameStr = ''
    for (let i = 0; i < modeData.length; i++) {
      idStr.push(modeData[i].id + '')
      nameStr += modeData[i].name + ','
    }
    for (let i = 0; i < formModel.column.length; i++) {
      if (formModel.column[i].prop === mainTable.buttonSetting.modeConf.toLabel) {
        formInstance[formModel.column[i].prop] = idStr
      }
      formInstance[modeProp] = nameStr.substring(0, nameStr.length - 1)
    }
  } else {
    for (let i = 0; i < formModel.column.length; i++) {
      if (formModel.column[i].prop === mainTable.buttonSetting.modeConf.toLabel) {
        formInstance[formModel.column[i].prop] = modeData.id
      }
      formInstance[modeProp] = modeData.name
    }
  }
}

/**
 * 下拉选择框的表单级联功能
 * @param modeldata
 * @param options
 * @param http
 * @param message
 */
export function cascadeLocal(modeldata, options, http, message) {
  let casIndex = []
  if (options.column && options.column.length > 0) {
    for (let i = 0; i < options.column.length; i++) {
      if (options.column[i].casUrl && options.column[i].casUrl.length > 0) {
        casIndex.push({ index: i, url: options.column[i].casUrl })
      }
    }
  }
  if (casIndex.length === 0) {
    return
  }
  for (let j = 0; j < casIndex.length; j++) {
    if (modeldata[options.column[casIndex[j].index].prop] && modeldata[options.column[casIndex[j].index].prop].length > 0) {
      http.post(casIndex[j].url, {}).then(res => {
      // http.get(casIndex[j].url + '/' + modeldata[options.column[casIndex[j].index].prop]).then(res => {
        if (res.code === 200) {
          if (res.data) {
            for (let key in res.data) {
              modeldata[key] = res.data[key]
            }
          }
        } else {
          message.error(res.msg)
        }
      }).catch(err => {
        if (err.msg) { message.error(err.msg) } else { message.error(err.message) }
      })
    }
  }
}

/**
 * 下拉选择框的对表单的显隐控制功能
 * @param modelData
 * @param options
 */
export function controlHideByCondition(modelData, options) { // 表单中元素的显隐控
  console.log(modelData)
  let propArr = []
  let indexArr = []
  if (options.column && options.column.length > 0) {
    for (let i = 0; i < options.column.length; i++) {
      if (options.column[i].dynamicHide && options.column[i].dynamicHide.length > 0) {
        indexArr.push(i)
        for (let j = 0; j < options.column[i].dynamicHide.length; j++) {
          propArr.push({ index: i, prop: options.column[i].dynamicHide[j].dynamicHideProp, condition: options.column[i].dynamicHide[j].dynamicHideCondition })
        }
      }
    }
    if (indexArr.length === 0) {
      return
    }
  }
  for (let k = 0; k < indexArr.length; k++) {
    if (modelData[options.column[indexArr[k]].prop] && modelData[options.column[indexArr[k]].prop].length > 0) {
      for (let m = 0; m < propArr.length; m++) {
        if (propArr[m].index === indexArr[k]) {
          for (let n = 0; n < options.column.length; n++) {
            if (options.column[n].prop === propArr[m].prop) {
              if (modelData[options.column[indexArr[k]].prop] === propArr[m].condition) {
                options.column[n].display = true
              } else {
                options.column[n].display = false
              }
            }
          }
        }
      }
    }
  }
}

/**
 * 日期格式化
 * @param date
 * @returns {string}
 */
export function dateFormat(date) {
  let newDate = new Date(date)
  let year = newDate.getFullYear()
  let month = newDate.getMonth() + 1
  let day = newDate.getDate()
  let hour = newDate.getHours()
  let minute = newDate.getMinutes()
  let second = newDate.getSeconds()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  hour = hour < 10 ? '0' + hour : hour
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
}

/**
 * 文件上传前的校验
 */

export function uploadBefore(file, done, loading, column, message) {
  // 1、文档[doc、docx、xls、xlsx、ppt、pptx、txt、pdf、md]；2、图片[jpg、jpeg、png、gif、bmp];3、视频[avi、mov、rmvb、rm、flv、mp4]；4、压缩包[rar、zip]。
  let fileArr = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'pdf', 'md', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'avi', 'mov', 'rmvb', 'rm', 'flv', 'mp4', 'rar', 'zip']
  if (fileArr.indexOf(file.name.split('.')[1]) !== -1) {
    column.fileNames.push(file.name)
    done()
  } else {
    message.info('文件格式不支持')
    loading()
  }
}

/**
 * 文件上传后将返回的文件唯一码写到表单数据中
 * @param ress
 * @param done
 * @param loading
 * @param column
 * @param modelData
 * @param downloadFile
 * @param message
 */
export function uploadAfter(ress, done, loading, column, modelData, downloadFile, message) {
  /* console.log(this.$refs.form)
    console.log(this.$refs.form.$children[0].$children[0].$children[0].$children[0].$children[0].$children[0].$children[1].$children[0].$children[0])
    let upload = this.$refs.form.$children[0].$children[0].$children[0].$children[0].$children[0].$children[0].$children[1].$children[0].$children[0]
*/

  console.log('after upload')
  console.log(modelData)
  console.log(ress)
  console.log(column.fileNames[column.fileNames.length - 1])
  console.log(done)
  downloadFile.get('/common/document/download?fileUniqueCode=' + ress.data, { params: {
    doDownload: false,
    fileName: column.fileNames[column.fileNames.length - 1]
  }}).then(res => {
    if (res.code === 200) {
      console.log('20000')
      console.log(modelData)
      if (column.listType === 'picture-img') {
        modelData[column.prop] = [{ 'label': column.fileNames[column.fileNames.length - 1], 'value': res.data.url, 'code': ress.data }]
      } else {
        modelData[column.prop].push({ 'label': column.fileNames[column.fileNames.length - 1], 'value': res.data.url, 'code': ress.data })
      }
      console.log(modelData)
    }
  }).catch(err => {
    message.error(err.msg)
  })
  setTimeout(() => {
    console.log('setTimeout')
    console.log(modelData)
    modelData[column.prop].splice(modelData[column.prop].length - 1, 1)
  })
  done()
}

/**
 * 在文件上传前设置token
 * @param options
 * @param token
 */
export function setHeaderBeforeFileUpload(options, token) {
  if (options && options.column.length > 0) {
    for (let i = 0; i < options.column.length; i++) {
      if (options.column[i].type === 'upload') {
        options.column[i].headers = Object.assign(options.column[i].headers, token)
      }
    }
  }
}

/**
 * 下拉框带参数的远端数据获取
 */
export function getRemoteDataByParams(options, http, message, modeldata) {
  return new Promise(function(resolve, reject) {
    console.log('hellow')
    console.log(modeldata)
    if (options.column && options.column.length > 0) {
      for (let i = 0; i < options.column.length; i++) {
        if (options.column[i].type === 'select' && options.column[i].paramUrl && options.column[i].paramUrl.length > 0) {
          if (options.column[i].dicUrl) { delete options.column[i].dicUrl }
          let requestParams
          console.log('requestParams')
          console.log(options.column[i].requestParams)
          if (options.column[i].requestParams && options.column[i].requestParams.length > 0) {
            requestParams = options.column[i].requestParams.split(',')
          }
          let params = {}
          requestParams.forEach(item => {
            params[item] = modeldata[item]
          })
          console.log('params')
          console.log(params)
          http.get(options.column[i].paramUrl, { params: params }).then(response => {
            if (response.code === 200) {
              console.log('response')
              console.log(response)
              options.column[i].dicData = response.data
              console.log(options.column[i].dicData)
              resolve()
            }
          }
          ).catch(err => {
            if (err.msg) {
              message.error(err.msg)
              reject()
            } else {
              message.error(err.message)
              reject()
            }
          })
        }
      }
      resolve()
    }
  })
}
